
export const callConstants = {
  GET_CALLS_REQUEST: 'GET_CALLS_REQUEST',
  GET_CALLS_SUCCESS: 'GET_CALLS_SUCCESS',
  GET_CALLS_FAILURE: 'GET_CALLS_FAILURE',

  GET_CALL_JURISDICTIONS_REQUEST: 'GET_CALL_JURISDICTIONS_REQUEST',
  GET_CALL_JURISDICTIONS_SUCCESS: 'GET_CALL_JURISDICTIONS_SUCCESS',
  GET_CALL_JURISDICTIONS_FAILURE: 'GET_CALL_JURISDICTIONS_FAILURE',

  GET_CALL_CITIES_REQUEST: 'GET_CALL_CITIES_REQUEST',
  GET_CALL_CITIES_SUCCESS: 'GET_CALL_CITIES_SUCCESS',
  GET_CALL_CITIES_FAILURE: 'GET_CALL_CITIES_FAILURE',

  GET_CALL_REQUEST: 'GET_CALL_REQUEST',
  GET_CALL_SUCCESS: 'GET_CALL_SUCCESS',
  GET_CALL_FAILURE: 'GET_CALL_FAILURE',

  ADD_CALL_REQUEST: 'ADD_CALL_REQUEST',
  ADD_CALL_SUCCESS: 'ADD_CALL_SUCCESS',
  ADD_CALL_FAILURE: 'ADD_CALL_FAILURE',

  ADD_BULK_CALL_REQUEST: 'ADD_BULK_CALL_REQUEST',
  ADD_BULK_CALL_SUCCESS: 'ADD_BULK_CALL_SUCCESS',
  ADD_BULK_CALL_FAILURE: 'ADD_BULK_CALL_FAILURE',

};
